// @flow
import * as React from 'react';
import styled from 'styled-components';

import ExternalLinkIcon from '../Icons/ExternalLink';

import colors from '../../assets/css/colors';

const Link = styled.a`
	display: flex;
	align-items: center;

	font-size: 14px;
	line-height: 1.5;
	color: ${colors.nrlGreen};
	text-decoration: none;

	margin: 16px 0;

`;

const ExternalLinkIconWrapper = styled.div`
	margin-left: 6px;
	margin-top: 2px;
`;

type Props = {
	children: any,
	href: string,
	rest?: Object
}

const ExternalLink = ({ children, href, ...rest }: Props) => (
	<Link href={href} {...rest} target="_blank" >
		{children}
		<ExternalLinkIconWrapper>
			<ExternalLinkIcon />
		</ExternalLinkIconWrapper>
	</Link>
);

export default ExternalLink;


// WEBPACK FOOTER //
// ./src/components/MenuPopout/ExternalLink.js